'use client'; // Error components must be Client Components

import NotFound from '@/src/components/NotFound';
import { Button } from '@/src/components/ui/button';
import Container from '@/src/components/ui/container';
import { Link } from '@/src/i18n/navigation';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

export default function Error({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  const t = useTranslations('error');

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <Container>
      <section className="h-full py-20 text-center">
        <NotFound title={t('wrong')} />
        <div className="mx-auto my-10 flex w-1/2 flex-wrap gap-4 lg:w-1/3 lg:flex-nowrap">
          <Button rounded={'full'} variant={'Error'} onClick={() => unstable_retry()}>
            {t('try-again')}
          </Button>
          <Link href={'/'} className="w-full">
            <Button rounded={'full'}>{t('go-home')}</Button>
          </Link>
        </div>
      </section>
    </Container>
  );
}
